export default "__VITE_ASSET__r0kGZ5pV__"